import type { FC } from 'react';
import { Modal } from '@ui';
import './index.scss';
import { observer } from 'mobx-react';

export interface SuccessMessageModalProps {
  messageType?: 'Return' | 'Review' | 'Question' | 'Comment';
  onPopupClose?: () => void;
}

const SuccessMessageModal: FC<SuccessMessageModalProps> = observer(
  ({ messageType, onPopupClose }) => {
    const info = {
      heading: '',
      text: ''
    };
    switch (messageType) {
      case 'Return':
        info.heading = 'Спасибо за вашу заявку.';
        info.text = 'Обработка займет некоторое время.';
        break;
      case 'Review':
        info.heading = 'Спасибо за Ваш отзыв.';
        info.text = 'Обработка займет некоторое время.';
        break;
      case 'Question':
        info.heading = 'Спасибо за ваш вопрос.';
        info.text =
          'Обработка займет некоторое время, после чего ответ будет направлен на электронную почту.';
        break;
      case 'Comment':
        info.heading = 'Спасибо за ваш комментарий.';
        info.text = 'Обработка займет некоторое время.';
        break;
      default:
    }

    return (
      <Modal
        framed
        crossOutside
        onClose={onPopupClose}
        placementMobile='bottom-sheet'
      >
        <div className='SuccessMessageModal'>
          <div className='SuccessMessageModal__heading'>{info.heading}</div>
          <div className='SuccessMessageModal__text'>{info.text}</div>
          <div onClick={onPopupClose} className='SuccessMessageModal__btn'>
            Закрыть
          </div>
        </div>
      </Modal>
    );
  }
);

export default SuccessMessageModal;
